<template>
	<el-button class="wp-button" type="small">
		<slot></slot>
	</el-button>
</template>

<script>
	export default {
		name: "WpButton",
	};
</script>

<style lang="less" scoped>
	.wp-button {
		border-radius: 40px;
	}
</style>


// WEBPACK FOOTER //
// src/components/WpButton.vue